module.exports = __webpack_public_path__ + "img/small-ship-wreck-grass-3.383fd65b.png";